import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    flex: '0 1 auto',
    height: 52,
    backgroundColor: '#fff',
    justifyContent: 'space-between',
    boxShadow: '0px 1px 0px #E2EBF6'
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center'
  },
  logo: {
    height: 'calc(80% - 4px)',
    marginTop: '8px'
  },
  navigation: {
    display: 'flex'
  },
  drawerNavigation: {
    width: 250,
    padding: theme.spacing(2)
  },
  navigationItems: {
    padding: '0 0 0 16px',
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  navigationItem: {
    fontSize: '13px',
    cursor: 'pointer',
    '&:not(:last-child)': {
      marginRight: 25
    },
    wordWrap: 'break-word',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      padding: '0 0 10px 0'
    },
    position: 'relative',
  },
  navigationItemLink: {
    display: 'inline-block',
    color: '#335267',
    padding: '8px 0',
  },
  activeNavigationLink: {
    color: '#071B27',
    fontWeight: 'bold'
  },
  headerActions: {
    display: 'flex',
    right: 0,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  createNewBtn: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '0 0 10px 14px'
    }
  },
  btnTitle: {
    paddingRight: '10px',
    color: '#0E8BB4'
  },
  createNewIcon: {
    fill: '#0E8BB4',
    width: '19px',
    height: '19px',
    marginRight: '5px'
  },
  btnActionWrapper: {
    display: 'flex',
    borderRight: '1px solid #E2EBF6',
    width: '120px',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      border: 'none'
    }
  },
  menu: {
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    position: 'absolute',
    top: '5px',
    backgroundColor: '#FFF',
    width: '165px',
    height: '60px'
  },
  businessOwnerNameWrapper: {
    width: '115px',
    display: 'flex',
    borderRight: '1px solid #E2EBF6',
    justifyContent: 'center'
  },
  languageSelectorWrapper: {
    width: '100px',
    display: 'flex',
    borderRight: '1px solid #E2EBF6',
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
      padding: '0 0 10px 14px'
    }
  },
  businessOwnerSelectorWrapper: {
    width: '-webkit-fill-available',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 20px',
    justifyContent: 'center',
    paddingTop: '8px !important',
    [theme.breakpoints.down('sm')]: {
      padding: '0 0 10px 14px'
    }
  },
  businessOwnerSelectorNotifySettings: {
    width: '120px',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 10px',
    borderRight: '1px solid #E2EBF6',
    justifyContent: 'center'
  },
  logOutBtn: {
    width: '100px',
    padding: '16px 20px'
  },
  logOutBtnTitle: {
    paddingRight: '10px',
    color: '#59758B'
  },
  businessOwnerName: {
    fontWeight: 'bold',
    fontSize: '15px'
  },
  selectedItem: {
    backgroundColor: '#E2F5F8 !important'
  },
  
  submenuContainer: {
    position: 'absolute',
    top: '100%',
    left: 0,
    backgroundColor: '#fff',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.15)',
    minWidth: '220px',
    zIndex: 1300,
    borderRadius: '4px',
    border: '1px solid #E2EBF6',
    marginTop: '4px'
  },
  
  submenu: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  
  submenuItem: {
    borderBottom: '1px solid #E2EBF6',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  
  submenuLink: {
    display: 'block',
    width: '100%',
    padding: '10px 16px',
    textAlign: 'left',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    color: '#335267',
    fontSize: '13px',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    
    '&:hover': {
      backgroundColor: '#F5F9FC',
      color: '#0E8BB4',
    },
  },
  
  activeSubmenuLink: {
    backgroundColor: '#E2F5F8',
    color: '#0E8BB4',
    fontWeight: '600',
    borderLeft: '3px solid #0E8BB4',
  },
  [theme.breakpoints.down('sm')]: {
    submenuContainer: {
      position: 'static',
      boxShadow: 'none',
      border: 'none',
      marginTop: '8px',
      marginLeft: '16px',
      minWidth: 'auto',
    },
    submenuLink: {
      padding: '8px 12px',
      fontSize: '12px',
    },
  }
}));

export default useStyles;
